import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToShopItems, type ShopListType } from "../model";

export const getCurrentShopItem = async (
  shopType: string,
  pageCount: number,
) => {
  const searchParams = {
    sort: ["createdAt:desc"],
    pagination: {
      page: pageCount || 1,
      pageSize: 6,
    },
    populate: {
      icon: {
        populate: "*",
      },
      mainImage: {
        populate: "*",
      },
    },
  };

  const shopItems = strapiClient.collection("merches");

  const list = await shopItems.find({
    ...searchParams,
  });

  return rebuild(mapDtoToShopItems(list)) as ShopListType;
};
